<script lang="ts">
    import {Component, Vue} from 'vue-facing-decorator'

    @Component
    export class ActivityPageMixin extends Vue {
        async loadRuntimeData() {
            if (
                !!this.$conf.public.searchWithoutDestination?.countryId &&
                activitiesRuntimeStore.country.id !== this.searchRequest.countryId
            ) {
                await activitiesRuntimeStore.loadCountry(this.searchRequest.countryId)
            }
            if (this.searchRequest.cityId && activitiesRuntimeStore.city.id !== this.searchRequest.cityId)
                await activitiesRuntimeStore.loadCity(this.searchRequest.cityId)
        }
    }

    export default ActivityPageMixin
</script>
